<template>  
  <div v-if="SelectedMarkup != null" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none" :style="{'top' : SelectedMarkup.Coords.Y + 60 + 'px', 'left' : SelectedMarkup.Coords.X + 'px', 'position' : 'absolute'}">
    <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 3px; padding-right: 3px">
      {{SelectedMarkup.Hint}}
    </div>
  </div>
  <div ref="ElementoGrafico">
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico"></canvas>
  </div>      
</template>

<script>
import { TZGraphLabelType, TZGraphMarkup, TZGraphNotchType } from '@/utils/ZGraph.js'
import { COLORI_ALLARME_CRONOLOGIA_ACC, SystemInformation, SPESSORE_LINEE_GRAFICI } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZGenericFunct } from '@/utils/ZGenericFunct'

export default 
{
  components: { },
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              ObjGrafico     : null,
              SelectedMarkup : null,
              Grafici        : {},
              LinguaUtente   : SystemInformation.UserInformation.Lingua,
              ColoriAllarme  : COLORI_ALLARME_CRONOLOGIA_ACC,
              SpessoreGrafico : SPESSORE_LINEE_GRAFICI,
           }

  },
  props: [ "WidthGrafico", "HeightGrafico", "Dati", "Repaint", "RepaintDeep", "Tipo", "LivelliAllarme", "TipoAmpiezza" ],

  methods:
  {
    GetMaxAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result < this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result > this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinDelta(Element)
    {
      return Math.min(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    GetMaxDelta(Element)
    {
      return Math.max(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    Adatta()
    {
      this.ObjGrafico.AxisX.Min = this.Dati.AxisX.Min
      this.ObjGrafico.AxisX.Max = this.Dati.AxisX.Max
      this.ObjGrafico.AxisX.NotchDim = this.Dati.AxisX.Udm
      this.ObjGrafico.AxisY.Max      = 0
      this.ObjGrafico.AxisY.Min      = this.Dati.AxisY.Max
      this.ObjGrafico.AxisY.FontSize = 13
      if(this.ObjGrafico.AxisY.Min <= 20)
        this.ObjGrafico.AxisY.NotchDim = 2
      else this.ObjGrafico.AxisY.NotchDim = this.Dati.AxisY.Udm
    },

    GetMousePosOncanvas(event)
    {
      this.ObjGrafico.AnnullaLastMarkup()
      this.SelectedMarkup = null
      this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(event.offsetX, event.offsetY)
    },

    InserisciDati()
    {
      this.ObjGrafico.ClearAllGroupPoint()
      let Grafico = this.ObjGrafico.AddGroupPoint(0, 'black', this.SpessoreGrafico, true)

      for (let i = 0; i < this.Dati.ListaPunti.length; i++)
      {
        let Punto = this.Dati.ListaPunti[i]
        let Valore = 0
        let ObjLivelliAllarme = {}
        let YCoord = Punto.Profondita
        let XCoord = Punto.DataInt
        let Colore = this.ColoriAllarme.Livello0

        if (this.TipoAmpiezza)
        {
          ObjLivelliAllarme = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.Ampiezza)
          Valore = Punto.MaxAmpiezza
        }
        else
        {
          ObjLivelliAllarme = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.Frequenza)
          Valore = Punto.Frequenza
        }
        if (Valore >= ObjLivelliAllarme.Terzo)
          Colore = this.ColoriAllarme.Livello3
        else
        {
          if (Valore >= ObjLivelliAllarme.Secondo)
            Colore = this.ColoriAllarme.Livello2
          else
            if (Valore >= ObjLivelliAllarme.Primo)           
              Colore = this.ColoriAllarme.Livello1
        }
        let Hint = Punto.Data + ' - ' + this.GetTraduzioneLabel('VUEComponenteGraficoCronologiaAcc','TKN_GRAF_CRON_ACC_HINT_MOD',this.LinguaUtente) + ' ' + Punto.Modulo + ' - ' + this.GetTraduzioneLabel('VUEComponenteGraficoCronologiaAcc','TKN_GRAF_CRON_ACC_HINT_MAX_AMP',this.LinguaUtente) + ' ' + Punto.MaxAmpiezza.toFixed(2) + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ' - ' + this.GetTraduzioneLabel('VUEComponenteGraficoCronologiaAcc','TKN_GRAF_CRON_ACC_HINT_N_EVENTI',this.LinguaUtente) + ' ' + Punto.Frequenza + ' - ' + this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ' ' + Punto.Profondita + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
        Grafico.AddPoint(XCoord, YCoord, Hint, [], null, Colore)
      }

    },

    Disegna()
    {
      this.Adatta()
      this.InserisciDati()
      setTimeout(() => { this.ObjGrafico.Paint()}, 1)
    },
  },

  computed:
  {
    PropsGraficoPerModifica :
    {
      get()
      {
        return this.Dati
      }
    }
  },

  watch:
  {
    Repaint:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.ObjGrafico.AxisX.Max      = this.Dati.AxisX.Max
          this.ObjGrafico.AxisX.Min      = this.Dati.AxisX.Min
          this.ObjGrafico.AxisX.NotchDim = this.Dati.AxisX.Udm
          this.ObjGrafico.AxisY.Max      = 0
          this.ObjGrafico.AxisY.Min      = this.Dati.AxisY.Max
          this.ObjGrafico.AxisY.NotchDim = this.Dati.AxisY.Udm
          this.ObjGrafico.AxisY.Inverted = true
          setTimeout(() => { this.ObjGrafico.Paint()}, 1)
        }
      }
    },

    RepaintDeep:
    {
      handler()
      {
        this.Disegna()
      }
    },
  },

  mounted()
  {
    this.ObjGrafico = new TZGraphMarkup(this.$refs.Canvas)
    this.PropsGraficoPerModifica.OggettoGrafico =  this.ObjGrafico;
    this.ObjGrafico.ShowFirstMarkup     = true
    this.ObjGrafico.VerticalLabelAxisX  = true
    this.ObjGrafico.AxisX.NotchFontSize = 13
    this.ObjGrafico.AxisY.FontSize      = 13
    this.ObjGrafico.AxisX.FontSize      = 15
    this.ObjGrafico.AxisX.NotchPenWidth = 1
    this.ObjGrafico.AxisY.NotchPenWidth = 1
    this.ObjGrafico.AxisX.NotchColor    = 'grey'
    this.ObjGrafico.AxisY.NotchColor    = 'grey'
    this.ObjGrafico.AxisY.CenterLabel   = this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'
    this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchFontSize = 13
    this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
    this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblInteger
    this.ObjGrafico.__Margins.MinBottom += 60
    this.ObjGrafico.__Margins.MinLeft   += 30

    this.ObjGrafico.AxisX.Min           = this.Dati.AxisX.Min    
    this.ObjGrafico.AxisX.Max           = this.Dati.AxisX.Max
    this.ObjGrafico.AxisX.NotchDim      = this.Dati.AxisX.Udm

    this.ObjGrafico.AxisY.Min           = this.Dati.AxisY.Max
    this.ObjGrafico.AxisY.Max           = 0
    this.ObjGrafico.AxisY.NotchDim      = this.Dati.AxisY.Udm
    this.InserisciDati()
    this.$refs.Canvas.addEventListener('mousemove', this.GetMousePosOncanvas)
    setTimeout(() => { this.ObjGrafico.Paint()}, 1)
  },

  beforeMount()
  {
    
  },
}
</script>